import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import AssignmentSubmissionForm from "../../components/student/assignment/AssignmentSubmissionForm";
import CourseVideos from "../../components/student/coursePlayer/CourseVideos";
import { useGetAssignmentMarkOfStudentQuery } from "../../features/assignmentMark/assignmentMarkAPI";
import { useGetAssignmentOfVideoQuery } from "../../features/assignments/assignmentsAPI";
import { setAssignmentMarkPayload } from "../../features/coursePlayer/coursePlayerSlice";
import { useGetQuizMarkOfStudentQuery } from "../../features/quizMark/quizMarkAPI";
import { useGetQuizzesOfVideoQuery } from "../../features/quizzes/quizzesAPI";
function CoursePlayer() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const video = useSelector((state) => state.coursePlayer.selectedVideo);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const {
    data: assignment,
    isLoading: isAssignmentLoading,
    isError: isAssignmentError,
    isSuccess: isAssignmentSuccess,
  } = useGetAssignmentOfVideoQuery(video?.id);

  const {
    data: assignmentMark,
    isLoading: assignmentMarkLoading,
    isError: assignmentMarkError,
  } = useGetAssignmentMarkOfStudentQuery({
    student_id: user?.id,
    assignment_id: assignment?.length > 0 ? assignment[0]?.id : null,
  });

  useEffect(() => {
    if (assignment?.length > 0 && assignmentMark?.length === 0) {
      const payload = {
        student_id: user?.id,
        student_name: user?.name,
        assignment_id: assignment[0]?.id,
        title: assignment[0]?.title,
        createdAt: null,
        totalMark: assignment[0]?.totalMark,
        mark: 0,
        repo_link: null,
        status: "pending",
      };

      dispatch(setAssignmentMarkPayload(payload));
    }
  }, [assignment, assignmentMark, user, dispatch]);

  const {
    data: quizzes,
    isLoading: isQuizzesLoading,
    isError: isQuizzesError,
    isSuccess: isQuizzesSuccess,
  } = useGetQuizzesOfVideoQuery(video?.id);

  const {
    data: quizMark,
    isLoading: quizMarkLoading,
    isError: quizMarkError,
    isSuccess: quizMarkSuccess,
  } = useGetQuizMarkOfStudentQuery({
    video_id: video?.id,
    student_id: user?.id,
  });

  let assignmentButton = null;
  if (isAssignmentLoading || assignmentMarkLoading)
    assignmentButton = "Loading...";
  else if (isAssignmentError || assignmentMarkError)
    assignmentButton = "Error fetching Assignment!";
  else if (
    isAssignmentSuccess &&
    assignment?.length === 0 &&
    assignmentMark?.length !== 0
  )
    assignmentButton = null;
  else if (
    isAssignmentSuccess &&
    assignment?.length > 0 &&
    assignmentMark?.length === 0
  )
    assignmentButton = (
      <span
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary cursor-pointer"
        onClick={() => setIsModalOpen(true)}
      >
        এসাইনমেন্ট
      </span>
    );

  let quizButton = null;
  if (isQuizzesLoading || quizMarkLoading) quizButton = "Loading...";
  else if (isQuizzesError || quizMarkError)
    quizButton = "Error fetching Quizzes!";
  else if (isQuizzesSuccess && quizzes?.length === 0) quizButton = null;
  else if (
    isQuizzesSuccess &&
    quizMarkSuccess &&
    quizzes?.length !== 0 &&
    quizMark?.length !== 0
  )
    quizButton = (
      <span className="px-3 font-bold py-1 border border-green text-green rounded-full text-sm hover:bg-cyan cursor-pointer">
        কুইজে অংশগ্রহণ করেছেন
      </span>
    );
  else if (
    isQuizzesSuccess &&
    quizzes?.length > 0 &&
    quizMarkSuccess &&
    quizMark?.length === 0
  )
    quizButton = (
      <Link
        to={`quiz/${video?.id}`}
        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary cursor-pointer"
      >
        কুইজে অংশগ্রহণ করুন
      </Link>
    );

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-7xl px-5 lg:px-0">
        <div className="grid grid-cols-3 gap-2 lg:gap-8">
          <div className="col-span-full w-full space-y-8 lg:col-span-2">
            <iframe
              width="100%"
              className="aspect-video"
              src={`${video?.url}`}
              title={`${video?.title}`}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>

            <div>
              <h1 className="text-lg font-semibold tracking-tight text-slate-100">
                {video?.title}
              </h1>
              <h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
                Uploaded on &nbsp;
                {video?.createdAt
                  ? new Date(video?.createdAt)?.toDateString()
                  : null}
              </h2>

              {/* Assignment & Quiz Section start */}
              <div className="flex gap-4">
                {assignmentButton} {quizButton}
              </div>
              {/* Assignment & Quiz Section start */}
              <p className="mt-4 text-sm text-slate-400 leading-6">
                {video?.description}
              </p>
            </div>
          </div>
          {/* Related Videos start */}
          <CourseVideos />
          {/* Related Videos start */}
        </div>
      </div>

      <AssignmentSubmissionForm
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        title={assignment?.length > 0 && assignment[0]?.title}
      />
    </section>
  );
}

export default CoursePlayer;
